<!-- TEMPLATE -->
<template>
  <div class="product-summary">
    <div class='row'>
      <div class='small-12 medium-12 large-12 hd-12 columns dashboard-content'>
        <dean-section-title content='true'>
            <span slot='title'>
              <span class='avenir-heavy'>Provisioning Services</span>
            </span>

          <dean-section-title-item
              :icon='plusIcon'
              :content="true"
              @click.native="sectionRoute('standingData.provisioningServices.add')"
          >
            Provisioning Service toevoegen
          </dean-section-title-item>
        </dean-section-title>

        <dean-table
            :data='servicesData'
            :columns="columns"
            :hover="true"
            @column-click='columnClick'
            @cell-click="cellClick($event, 'standingData.provisioningServices.edit')">
        </dean-table>
      </div>
    </div>
  </div>
</template>

<!-- SCRIPT -->
<script lang="ts">
import { Component } from 'vue-property-decorator';
import deanTableMixin from '@/mixins/deanTableMixin';
import {mixins} from 'vue-class-component';
import deanFormRow from '@/components/deanComponents/deanFormRow.vue';

import {
  // ICONS
  plusIcon,
  // COMPONENTS
  deanSectionTitle,
  deanSectionTitleItem,
  deanTable,
  deanPagination,
} from '@deanone/dean-components';

@Component({
  components: {
    plusIcon,
    deanSectionTitle,
    deanSectionTitleItem,
    deanTable,
    deanPagination,
    deanFormRow,
  },
})

export default class List extends mixins(deanTableMixin) {
  public services: any = [];
  public plusIcon: object = plusIcon;
  public queryTimeout!: number;

  // COMPUTED
  get servicesData() {
    return this.services;
  }

  public columns: { [name: string]: object } = {
    name: {
      content: 'Naam',
      sort: false,
      align: 'left',
    },
    commercialName: {
      content: 'Handelsnaam',
      sort: false,
      align: 'left',
    },
    isActive: {
      content: 'Actief',
      sort: false,
      align: 'center',
    },
    bundles: {
      content: 'Bundles',
      sort: false,
      align: 'left',
    },
    sort: {
      content: 'Soort',
      sort: false,
      align: 'center',
    },
  };

  get provisioningServicesSideMenu(): object {
    return {
      title: {
        text: 'Provisioning Services',
        mobile: {
          close: {
            text: 'Close',
          },
        },
      },
      filters: {},
    };
  }

  public tableName(): string {
    return 'settings-provisioning-services';
  }

  // METHODS
  public loadList(): void {
    this.$store.dispatch('setLoadOverlay', true);
    this.$store.dispatch('requestProvisioningServices')
        .then(
            (response: any) => {
              this.services = response.data.map((service: any) => {
                return {
                  id: service.identifier,
                  name: service.name,
                  commercialName: service.commercialName,
                  isActive: service.isActive ? 'Ja' : 'Nee',
                  bundles: service.bundles ?
                      service.bundles.map((bundle: any) => bundle.name).join(', ') : '-',
                  sort: service.sort,
                };
              });
            },
            (error: any) => {
              this.$toast(this.$store.state.main.notification.messages.couldNotReceiveData);
            },
        )
        .finally(
            () => {
              this.$store.dispatch('setLoadOverlay', false);
            },
        );
  }

  public cellClick(target: any): void {
    this.$router.push({
      name: 'standingData.provisioningServices.edit',
      params: {id: target.row.id},
    });
  }

  public created() {
    this.setDefaultSort('name');

    this.loadList();

    this.$store.dispatch('setStandingDataSideMenu', this.provisioningServicesSideMenu);
  }

  public update(timeout: boolean) {
    if (timeout) {
      if (this.queryTimeout) {
        clearTimeout(this.queryTimeout);
      }
      this.queryTimeout = setTimeout(() => {
        this.loadList();
      }, 500);
    } else {
      this.loadList();
    }
  }
}
</script>
<!-- STYLE -->
<style lang="scss" scoped>
@import '~@deanone/dean-components/src/scss/vars';

filter {
  display: flex;
}

.top-bar {
  display: inline-block;
}
</style>